import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "../HeightPin";
import ScrollSection from "../ScrollSection";
import GemDiscover from "../elements/GemDiscover";
import MoodBoard from "../MoodBoard"
import ImageCirclePack from "../charts/ImageCirclePack";
import TreeMap from "../charts/TreeMap";
import CardFlip from "../elements/CardFlip";
import SectionTop from "./SectionTop";
import WhatsImportant from "../elements/WhatsImportant";
import WhatsImportantResults from "../elements/WhatsImportantResults";
import {getAltText, getSectionImage, getInfoClass, getImageInfoStyle} from "../../assets/settings";

function CampusPlanning(props) {
    const {store, state, color, index, downhill} = props;
    const {circlePackStore} = store;

    const group = 'CP';
    const activeKey = store.activeSection(group) || 'CP_2';


    const sectionY = 0.35;

    return (
        <div className={'Section'}>
            <SectionTop group={group} downhill={downhill}>
                    <h4>What does it mean to have a campus plan?</h4>
                    <p>
                      Campus planning outlines the long-term direction of UC Berkeley’s built environment and landscape, and it ensures the best use of limited land and other resources.
                    </p>
                    <p>
                      A multiyear process is underway to update UC Berkeley’s two guiding campus planning documents: the Long Range Development Plan and Campus Master Plan. Both documents address topics like classrooms and research space, housing, transportation, and sustainability through an integrated planning lens.
                    </p>
                    <p>
                      “Integrated planning” means that these needs are considered holistically, to ensure that solutions reinforce and support multiple goals.
                    </p>
                    <div>
                    For example, an academic need, such as finding a location for a new classroom building, will spark questions about mobility, landscape, and campus character:
                      <ul>
                        <li>How large of a building is needed to meet classroom space needs?</li>
                        <li>How will students get there?</li>
                        <li>Are there other related campus needs that should be incorporated into the design or building program?</li>
                        <li>How will the new building fit in with adjacent buildings and landscape?</li>
                      </ul>
                    </div>
                    <p className="photocredit">
                      Photo Credit: Alan Nyiri
                    </p>
            </SectionTop>
            <HeightPin store={store} state={state} scrollChild={<div className={'left-scroll'}>
                <div className={'spacer'} style={{height: 150}}/>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CP_2`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CP_2')}>
                      <h4>Sometimes there are not easy answers to these questions.</h4>
                      <p>
                        Integrated planning considers the trade offs of different responses and charts a path forward to enable decision making.
                      </p>
                      <p>
                        How do we balance the need for more space for things like classrooms, research labs, academic support services, housing, and recreation with the need to maintain existing spaces that make the Berkeley campus a special place?
                      </p>
                      <p>
                        We’ll ask for your input on questions like these throughout this virtual open house.
                      </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CP_3`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CP_3')}>
                      <h4>This is an opportunity for the campus community and other stakeholders to envision what the physical campus will be like in 15 to 20 years.</h4>
                      <p>
                        In a nutshell, the <a target="_blank" href="https://lrdp.berkeley.edu/documents">Long Range Development Plan</a> and <a target="_blank" href="https://masterplan.berkeley.edu/documents">Campus Master Plan</a> are two separate documents that guide the physical development of the campus. Both plans are flexible and long-term, and respond to the strategic academic program needs outlined in UC Berkeley’s recently updated Strategic Plan.
                      </p>
                      <p>
                        The Long Range Development Plan is a land use plan and an organizational development framework, while the Campus Master Plan identifies specific projects and how the university might implement them.
                      </p>
                      <p>
                        Learn more:
                      </p>
                      <ul>
                        <li>
                          <a target={'_blank'} href="https://lrdp.berkeley.edu/">Long Range Development Plan</a>
                        </li>
                        <li>
                          <a target={'_blank'} href="https://strategicplan.berkeley.edu/">Strategic Plan</a>
                        </li>
                      </ul>
                    </div>
                </ScrollSection>
                <div className={'spacer'} style={{height: '50vh'}}/>
            </div>}
                       pinChild={<div className={'sticky-image-right'}>
                           <div className={'frame'}>
                               {getAltText(activeKey).title && <h4 style={{'backgroundColor': color + '80'}}>{getAltText(activeKey).title}</h4>}
                               <img width={'100%'} src={getSectionImage(group, activeKey)} alt={getAltText(activeKey).alt}/>
                           </div>
                       </div>}
            />
            <div className={'interactive'}>
                <CardFlip color={color} index={index} store={store}
                          frontFace={<WhatsImportant store={store} color={color}/>}
                          backFace={<Fragment>
                              <div className={'wi-spacer'} style={{height: '15%'}}/>
                              <WhatsImportantResults store={store} color={color} />
                              {/*<GemDiscover store={store} color={color} index={index}/>*/}

                          </Fragment>}/>
            </div>
        </div>
    );
}

export default observer(CampusPlanning);
